import { useUpdateFunnelStepQuery } from 'modules/funnels/funnel/hooks/use-update-funnel-step-query'
import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import {
  SplitTestComponentTypeEnum,
  SplitTestComponentTypeTitles,
} from '../../enums/split-tests-component-type-enum'
import WebsiteIcon from '../../icons/website-icon'
import { FunnelStepId } from '../../types/funnel-step-interface'

interface SplitTestItemProps {
  type: SplitTestComponentTypeEnum
  funnelStep: { id: FunnelStepId; name: string }
  className?: string
}

function SplitTestItem({ type, funnelStep, className }: SplitTestItemProps) {
  const { t } = useLocoTranslation()
  const { updateFunnelStepQuery } = useUpdateFunnelStepQuery()

  const handleClick = () => {
    updateFunnelStepQuery(funnelStep.id)
  }

  return (
    <div
      className={`font-inter text-text-primary flex flex-[33_1_0%] flex-col items-center justify-start gap-4 text-xl xl:w-[280px] ${className}`}
    >
      <WebsiteIcon
        className="h-[73px] w-[85px] cursor-pointer lg:h-[104px] lg:w-[121px]"
        onClick={handleClick}
      />
      <div className="flex flex-col items-center justify-center gap-1 text-[15px] lg:text-base">
        <div className="text-center opacity-60">{t(SplitTestComponentTypeTitles[type])}</div>
        <div className="text-center font-bold">{funnelStep.name}</div>
      </div>
    </div>
  )
}

export default SplitTestItem
